module.exports = __webpack_public_path__ + "static/img/2_1_3.9f3f4c6a.jpg";